<template>
  <div class="page">
    <div class="header">
      <div class="nav">
        <div class="nav_content">修改{{ title }}</div>
      </div>
      <div class="nav-left" @click="goBack"><img src="../../assets/new/left_b.svg" alt="" /></div>
    </div>
    <van-form ref="formRef">
      <div class="group_1">
        <div class="box_1">
          <van-field v-model="info" :label="title" />
        </div>
      </div>

      <!-- 操作按钮 -->
      <div class="btns">
        <van-button block @click="submit" type="info">保存</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import { doUpdatePerson } from '../../api/my';
import { Dialog } from 'vant';
export default {
  data() {
    return {
      userInfo: '',
      title: '',
      info: '',
      type: ''
    };
  },
  created() {
    this.title = this.$route.query.name;
    this.info = this.$route.query.value;
    this.type = this.$route.query.type;
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    //更新
    submit() {
      if (this.type == 'email') {
        if (this.info == '') {
          Dialog.alert({
            message: '电子邮箱不能为空',
            confirmButtonColor: '#2A70F2'
          }).then(() => {});
        } else {
          const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
          if (!emailRegex.test(this.info)) {
            Dialog.alert({
              message: '请输入有效的电子邮箱格式',
              confirmButtonColor: '#2A70F2'
            }).then(() => {});
          } else {
            this.gotoUpdate();
          }
        }
      } else if (this.type == 'organization') {
        if (this.info == '') {
          Dialog.alert({
            message: '单位名称不能为空',
            confirmButtonColor: '#2A70F2'
          }).then(() => {});
        }else{
            this.gotoUpdate();

        }
      } else if (this.type == 'infoAddress') {
        if (this.info == '') {
          Dialog.alert({
            message: '单位地址不能为空',
            confirmButtonColor: '#2A70F2'
          }).then(() => {});
        }else{
            this.gotoUpdate();

        }
      }
    },
    gotoUpdate() {
      const params = {
        type: this.$route.query.type,
        sValue: this.info
      };
      doUpdatePerson(params).then(res => {
        if (res.data.code == '200') {
          this.$utils.showToast('修改成功');
          this.$router.go(-1);
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.page {
  height: 100vh;
  background: #f6f8fa;
}
.group_1 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .box_1 {
    width: 100%;
    margin-top: 12px;
    // min-height: 360px;
    padding: 0 15px;
    background: #ffffff;
    border-radius: 8px;
    .avater {
      border-bottom: 1px solid #f5f6f7;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .avater_1 {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 8px;
        cursor: pointer;
      }
      .text_1 {
        font-size: 14px;
        color: #646566;
      }
    }
  }
}

.btns {
  margin: 20px 15px;
}

::v-deep {
  .van-cell-group--inset {
    margin: 0;
    border-top: 0;
  }
  .van-cell-group--inset::after {
    border: 0;
  }
  .van-cell {
    padding: 0;
    display: flex;
    align-items: center;
    height: 56px;
  }
  .van-cell::after {
    border-bottom: 1px solid #ebedf0;
    width: 315px;
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
  }
  .van-icon {
    color: #969799;
  }
}
.header {
  position: relative;
  width: 100%;
  height: 46px;
  background: #fff;
  border-radius: 0px 0px 0px 0px;
}
.nav {
  padding: 0 15px;
  height: 46px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.nav-left {
  position: absolute;
  top: 15px;
  left: 15px;
}
.nav_content {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 17px;
  color: #333;
}
</style>
